import React from "react";
import html2canvas from "html2canvas";
import { Box } from "@mui/material";
import DocDownloadImg from "../../assets/Images/CommonImages/document-download.svg";
import jsPDF from "jspdf";



const PageDownload = ({ pageref, name, taxInvoice }) => {
  const handleDownload = async () => {
    const landscapeOrPortrait = taxInvoice ? "portrait" : "landscape";
    html2canvas(pageref.current, {
        scale: 2,
        useCORS: true,
        logging: false,
    })
    .then((canvas) => {
        const pdf = new jsPDF(landscapeOrPortrait, "mm", "a4");
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();

        const margin = 2;
        const imgWidth = pdfWidth - 2 * margin;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        // Set yPos to margin so it starts from the top
        const yPos = margin;

        const imgData = canvas.toDataURL("image/png");
        pdf.addImage(imgData, "PNG", margin, yPos, imgWidth, imgHeight);

        pdf.save(name);
    })
    .catch((error) => {
        console.error("Error generating PDF:", error);
    });
};


  return <Box
    component="img"
    src={DocDownloadImg}
    sx={{ width: "22px", height: "auto", cursor: "pointer" }}
    onClick={handleDownload}
  />;
};

export default PageDownload;
